var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Rectangle from "terriajs-cesium/Source/Core/Rectangle";
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import ModelTraits from "../ModelTraits";
import { RectangleTraits } from "../TraitsClasses/MappableTraits";
export let SearchBarTraits = (_dec = primitiveTrait({
  type: "string",
  name: "placeholder",
  description: "Input text field placeholder shown when no input has been given yet. The string is translateable."
}), _dec2 = primitiveTrait({
  type: "number",
  name: "Recommended list length",
  description: "Maximum amount of entries in the suggestion list."
}), _dec3 = primitiveTrait({
  type: "number",
  name: "Flight duration seconds",
  description: "The duration of the camera flight to an entered location, in seconds."
}), _dec4 = primitiveTrait({
  type: "number",
  name: "Minimum characters",
  description: "Minimum number of characters required for search to start"
}), _dec5 = primitiveTrait({
  type: "boolean",
  name: "Show 'Search In Catalog'",
  description: "Whether to show 'Search In Catalog' in search results"
}), _dec6 = objectTrait({
  type: RectangleTraits,
  name: "Bounding box limit",
  description: "Bounding box limits for the search results {west, south, east, north}"
}), _class = class SearchBarTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "placeholder", _descriptor, this);
    _initializerDefineProperty(this, "recommendedListLength", _descriptor2, this);
    _initializerDefineProperty(this, "flightDurationSeconds", _descriptor3, this);
    _initializerDefineProperty(this, "minCharacters", _descriptor4, this);
    _initializerDefineProperty(this, "showSearchInCatalog", _descriptor5, this);
    _initializerDefineProperty(this, "boundingBoxLimit", _descriptor6, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "placeholder", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "translate#search.placeholder";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "recommendedListLength", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 5;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "flightDurationSeconds", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1.5;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "minCharacters", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 3;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showSearchInCatalog", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "boundingBoxLimit", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return Rectangle.MAX_VALUE;
  }
}), _class);